import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClearToast, SetToast, DismissToast } from '../actions/toaster';

import Toast from './UI/Toast';

const Toaster = (props) => {
  const { toast } = props;
  const { show, text, type, isOnRight, buttonText, buttonAction, position } =
    toast;

  useEffect(() => {
    let timeout;
    if (show) {
      // Don't auto-dismiss if there's an undo button (user needs time to click it)
      const timeoutDuration = buttonText ? 10000 : 20000;
      timeout = setTimeout(() => {
        props.DismissToast();
      }, timeoutDuration);
    }
    if (!show) clearTimeout(timeout);
    return () => clearTimeout(timeout);
  }, [show, buttonText]);

  return (
    <Toast
      toastIn={show}
      text={text}
      type={type}
      isOnRight={isOnRight}
      position={position}
      buttonText={buttonText}
      buttonAction={buttonAction}
      closeAction={() => {
        props.DismissToast();
      }}
      isDismissable
    />
  );
};

function mapStateToProps(state) {
  return {
    toast: state.toaster,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      SetToast,
      ClearToast,
      DismissToast,
    },
    dispatch
  );
}

Toaster.defaultProps = {
  toast: {
    text: 'I’m a toast',
    type: 'success',
    show: false,
    isOnRight: false,
  },
};

Toaster.propTypes = {
  DismissToast: PropTypes.func.isRequired,
  ClearToast: PropTypes.func.isRequired,
  toast: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string,
    show: PropTypes.bool,
    isOnRight: PropTypes.bool,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
